import {SmartComponent} from "smart-component-js";
class HomeCtrl extends SmartComponent {

	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.init();
	}
	init() {
		this.loadChildComponents(this);
	}
}

export default HomeCtrl;
